// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Ulrich Mierendorff, Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : Database Administration and Debugging Parts
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { loadLazy as ll } from 'uix/parts';
import log from 'uix/logging';
// ---Globals
export const DatabaseSchema = ll(import(/* webpackChunkName: 'database' */ './schema'));
export const DatabaseActivities = ll(import(/* webpackChunkName: 'database' */ './activities'));
export const DatabaseBackup = ll(import(/* webpackChunkName: 'database' */ './backup'));
export const DatabaseUpdates = ll(import(/* webpackChunkName: 'database' */ './updates'));
export const DatabaseDashboard = ll(import(/* webpackChunkName: 'database' */ './dashboard'));
export const DatabaseCommand = ll(import(/* webpackChunkName: 'database' */ './command'));
export const DatabaseTableStats = ll(import(/* webpackChunkName: 'database' */ './tablestats'));
export const DatabaseIndexes = ll(import(/* webpackChunkName: 'database' */ './indexes'));
